import { css } from '@linaria/core';
import { icon } from '../../atoms/icon/icon.styles';
import theme from '../../../theme';

const breadcrumbScrollable = css``;

const breadcrumbsItem = css``;

const breadcrumbsItemStatic = css``;

const breadcrumbsSeparator = css``;

const breadcrumbs = css`
  display: flex;
  align-items: center;
  gap: 8px;
  .${breadcrumbsItem} {
    font-weight: 400;
    display: inline-flex;
    align-items: center;
    white-space: nowrap;
    color: ${theme.colors.neutral[100]};
    &.${breadcrumbsItemStatic} {
      color: ${theme.colors.neutral[90]};
      font-weight: 300;
    }
  }

  .${icon} {
    font-size: 16px;
  }

  .${breadcrumbsSeparator} {
    color: ${theme.colors.neutral[40]};
  }
`;

export default {
  root: breadcrumbScrollable,
  breadcrumbs,
  item: breadcrumbsItem,
  staticItem: breadcrumbsItemStatic,
  separator: breadcrumbsSeparator,
};
